import React from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonImg,
    IonTitle,
    IonContent
} from '@ionic/react';

interface Props {
    visible: boolean;
}

const UpdateMessage: React.FC<Props> = ({ visible }) => {
    if (!visible) return null;

    return (
        <IonPage>
            <IonContent fullscreen className="ion-padding">
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    textAlign: 'center',
                    zIndex: 9999
                }}>
                    <h2>Please Update</h2>
                    <p>You need to update Event Pulse before using it.</p>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default UpdateMessage;
